module.exports = __webpack_public_path__ + "static/media/ER.2336c691.svg";